import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Typography, Box } from '@material-ui/core';
import cx from 'classnames';
import LinkButton from 'sharedComponents/LinkButton';
import { PlusIcon } from 'sharedComponents/Icons';

const CreateProfileButton = ({ classes, onClick, className }) => (
  <Box className={cx(classes.container, className)} onClick={onClick}>
    <LinkButton className={classes.plusButton}>
      <Icon component={PlusIcon} className={classes.icon} />
    </LinkButton>
    <Typography className={classes.buttonLabel}>Add Client</Typography>
  </Box>
);

CreateProfileButton.propTypes = {
  classes: PropTypes.shape({}),
  onClick: PropTypes.func.isRequired,
};

CreateProfileButton.defaultProps = {
  classes: {},
};

export default CreateProfileButton;
